export default __webpack_public_path__ + "static/media/gym-Commision.9450c7df.jpg";